<template>
    <div name="navigation" :class="{'navigation': true, 'fixed': isScrolled}" >
        <div class="header">
            <div class="logo-area">
                <img class="logo" src="../../assets/basic/pc/logo.png" alt="soldoc+"/>
                <img class="logo-blue" src="../../assets/pc_barocare/logo_blue.png" alt="soldoc+"/>
            </div>
            <div class="menu">
                <ul class="link-list">
                    <li><a href="#introduction" class="link-item link-item1" @click="goIntro">바로돌봄이란</a></li>
                    <li><a href="#reason" class="link-item link-item2" @click="goReason">왜 바로돌봄일까요?</a></li>
                    <li><a href="#review" class="link-item link-item3" @click="goReview">이용 후기</a></li>
                    <li><a href="#barocare-story" class="link-item link-item4" @click="goBarocareStory">제휴 신청</a></li>
                </ul>
            </div>
            <div class="btn-area">
                <a href="https://admin.soldoc.co.kr/auth/login" class="btn-barocare">바로돌봄 접속하기</a>
            </div>
        </div>       
    </div>
</template>

<script>
export default {
    name: 'navigation',
    data() {
    return {
        isScrolled: false
        };
    },
    mounted: function()
    {
        $('html').animate({
            scrollTop: 0
        }, 100);
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        goSign: function()
        {
            window.open('https://partner.soldoc.co.kr/', '_blank')
        },
        goIntro: function()
        {
            var element = document.getElementById("introduction");
            if (element) {
            element.scrollIntoView({ behavior: "smooth" });
            }
        },
        goReason: function()
        {
            var element = document.getElementById("reason");
            if (element) {
            element.scrollIntoView({ behavior: "smooth" });
            }
        },
        goReview: function()
        {
            var element = document.getElementById("review");
            if (element) {
            element.scrollIntoView({ behavior: "smooth" });
            }
        },
        // goPartner: function()
        // {
        //     var element = document.getElementById("partner");
        //     if (element) {
        //     element.scrollIntoView({ behavior: "smooth" });
        //     }
        // },
        goBarocareStory: function()
        {
            var element = document.getElementById("barocare-story");
            if (element) {
            element.scrollIntoView({ behavior: "smooth" });
            }
        },
        handleScroll() {
            var vhHeight = window.innerHeight / 100;
            var oneVh = 100 * vhHeight / 1.3;
            var element = document.getElementById("introduction").offsetTop - oneVh;
            if (window.scrollY >= element) {
                this.isScrolled = true;
            } else {
                this.isScrolled = false;
            }
        },
        
    }
}
</script>

<style scoped>
    .navigation {
        position: fixed;
        top:0;
        width: 100%;
        height: 105px;
        /* background: #555; */
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        z-index: 100;
    }
    .navigation.fadeout{
        animation: fadeOutUp 1s;
    }
    .navigation.fixed{
        position: fixed;
        height: 80px;
        background:#fff;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
        animation: fadeInUp 1s;
    }
    .navigation.fixed .header{
        margin-top: 0;      
    }
    .navigation.fixed .logo{
        display: none;
    }
    .navigation.fixed .logo-blue{
        display: block;
    }
    .navigation.fixed .link-item{
        color: #1A1A1A;    
    }
    .navigation.fixed .btn-barocare{
        background: #fff;
        border: 1px solid #0082EC;
        color: #0082EC;     
    }
    .navigation.fixed .btn-barocare:hover{
        background: #0082EC;
        color: #fff;     
    }
    .header {
        position: fixed;
        position: sticky;
        top: 0;
        display: flex;
        width: 100%;
        min-width: 960px;
        max-width: 1320px;
        padding: 0 20px;
        height: 80px;
        margin-top: 30px;
        justify-content: space-between;
        align-items: center;
    }
    .logo-area{
        width: 106px;
        margin-top: -5px;
    }
    .logo-area img{
        width: 100%;
    }
    .logo-blue{
        display: none;
    }
    .menu{
        padding-left: 100px;
    }
    .link-list{
        display: flex;
        align-items: center;
        width: 618px;
        height: 80px;
        list-style-type: none;
        padding: 0;
        margin: 0;
    }
    .link-list .link-item{
        padding: 20px 19px;
        color: #FFF;
        font-size: 18px;
        font-family: 'Apple SD Gothic Neo';
        font-style: normal;
        font-weight: 600;
        line-height: 26px;
        cursor: pointer;
        border: none;
        background: transparent;
        text-decoration:none;
    }
    .btn-area{
        margin-top: 10px;
    }
    .btn-barocare{
        display: inline-flex;
        min-height: 50px;
        padding: 7px 28px;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        border: 1px solid #fff;
        background: rgba(0, 0, 0, 0.10);
        color: #FFF;
        text-align: center;
        font-size: 16px;
        font-family: 'Pretendard';
        font-weight: 400;
        line-height: 1.3;
        cursor: pointer;
        text-decoration: none; 
    }
    .btn-barocare:hover{
        background: #FFF;
        color: #0082EC;
        font-weight: 600;
        text-decoration: none; 
    }
    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, -50%, 0);
        }
        to {
            opacity: 1;
            transform: translate3d(0, 0%, 0);
        }
    }
    @keyframes fadeOutUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 0%, 0);
        }
        to {
            opacity: 1;
            transform: translate3d(0, -50%, 0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_barocare/Navigation.vue